module.exports = [{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-catch-links@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@8.57.1_suppor_363a1b50debc5043754837e7de330903/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-styled-components@6.16.0_babel-plugin-styled-components@1.13.3_styled-com_be5b3a42dc725dd95a6afd7cfc849fa0/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@8.57.1_supports-color@5.5.0___react-dom@18.0.0_29117ed7713302872921648d7b728fd5/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
